import { MantineThemeOverride } from '@mantine/core';

export type FocusTrapTheme = NonNullable<MantineThemeOverride['components']>['FocusTrap'];

export const FocusTrap: FocusTrapTheme = {
  // todo: define
};
